import { render } from "./photoListSYC.vue?vue&type=template&id=750a1a56&ts=true"
import script from "./photoListSYC.vue?vue&type=script&lang=ts"
export * from "./photoListSYC.vue?vue&type=script&lang=ts"

import "./photoListSYC.vue?vue&type=style&index=0&id=750a1a56&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__